import { render, staticRenderFns } from "./Task-item.vue?vue&type=template&id=bb7ceea0&"
import script from "./Task-item.vue?vue&type=script&lang=js&"
export * from "./Task-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports